import MainBlog from "../components/blog/MainBlog";

function Blog() {
  return <MainBlog />;
}

export default Blog;
